import * as React from "react";
import { locKeys } from "./l10n";
import { ILocalization, LocalizedText } from "bernie-l10n";

export const PackageDisabledMessage = ({
  l10n,
  disablePackageOptions,
  isPackageEnabled,
  totalTravelers
}: {
  l10n: ILocalization;
  disablePackageOptions?: boolean;
  isPackageEnabled: boolean;
  totalTravelers: number;
}) => {
  if (!disablePackageOptions) {
    return null;
  }

  const message =
    totalTravelers > 6
      ? locKeys.invalidNumberOfTravelersForPackage
      : locKeys.packageDisabledMessage;

  const pdmPaddings = "all-t-padding-two m-l-padding-four l-l-padding-four xl-l-padding-four";

  return (
    <div className={`uitk-type-paragraph-300 packageDisabledMessage ${pdmPaddings}`}>
      <p>
        <LocalizedText message={message} />
      </p>
    </div>
  );
};
